import { render } from "./NotifiableUsersBlock.vue?vue&type=template&id=6aa0c2a9"
import script from "./NotifiableUsersBlock.vue?vue&type=script&lang=js"
export * from "./NotifiableUsersBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/NotifiableUsersBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6aa0c2a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6aa0c2a9', __exports__)) {
    api.reload('6aa0c2a9', __exports__)
  }
  
  module.hot.accept("./NotifiableUsersBlock.vue?vue&type=template&id=6aa0c2a9", () => {
    api.rerender('6aa0c2a9', render)
  })

}


export default __exports__